/**
 * Core-100 R4 wave 3 (CORE-BE B) — the ONE test of "is this ticket part of a rollover chain".
 *
 * `tickets.sequence_index` DEFAULTS TO 1 in the database, so every ticket created by a path that does not name the
 * column (most creation paths) carries `sequence_index = 1` while being part of no chain at all. Three copies of this
 * test (`isPartOfRolloverChain`, `useEODMonitor`, `checkEODViolation`) treated ANY non-null / truthy sequence_index as
 * chain membership, so for such a ticket the paused-visit EOD monitor and the EOD check returned early — a paused
 * visit running past its technician's end of day was never raised.
 *
 * What actually marks a chain, as every producer writes it:
 *   - a continuation names its predecessor (`rollover_of_ticket_id`) and its root (`parent_ticket_id`) and carries a
 *     generation ≥ 2 (EOD rollover handler, the server chain re-plan, OptiPlace/Catalyst continuations, manual split);
 *   - a root carries `split_reason` 'EOD_ROLLOVER' / 'EOD' (and, from the EOD handler, `parent_ticket_id` = itself).
 * Generation 1 is the root's number AND the column default, so on its own it says nothing; generation ≥ 2 still
 * counts (a continuation whose lineage columns were lost stays recognised as one).
 */
export interface RolloverChainMembershipFields {
  parent_ticket_id?: string | null;
  sequence_index?: number | null;
  rollover_of_ticket_id?: string | null;
  split_reason?: string | null;
}

export function isPartOfRolloverChain(ticket: RolloverChainMembershipFields | null | undefined): boolean {
  if (!ticket) return false;
  return !!(
    ticket.parent_ticket_id ||
    ticket.rollover_of_ticket_id ||
    (typeof ticket.sequence_index === 'number' && ticket.sequence_index > 1) ||
    ticket.split_reason === 'EOD' ||
    ticket.split_reason === 'EOD_ROLLOVER'
  );
}
